import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useForm } from "react-hook-form";

import AuthService from "../../../services/auth.service";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import SpinnerComponent from "../../../components/Loder/spinner";
import Helper from "../../../Helper";


const SignUp = () => {
  let navigate = useNavigate();
  const { register, handleSubmit, formState: { errors }, trigger } = useForm();
  const form = useRef();
  const checkBtn = useRef();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [company_name, setCompnayName] = useState("");
  const [address, setAddress] = useState("");
  const [country_name, setCountry] = useState([]);
  const [state_name, setState] = useState([]);
  const [city, setCity] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [userAllow, setUserAllow] = useState("1");
  const [country, setCountryid] = useState("");
  const [state, setStateid] = useState("");
  const [ipAddress, setIPAddress] = useState('')

  // const [stripee, setStripe] = useState(null);
  const [plan, setPlan] = useState("Free");
  const [amount, setAmount] = useState(0);
  const [paymentintent, setPaymentIntent] = useState('');
  const [updatestripeintent, setUpdatestripeintent] = useState(false)
  const [planData, setplanData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [start_date, setStart_date] = useState('')
  const [end_date, setEnd_date] = useState('')

  const generatePassword = () => {
    const uppercaseLetter = String.fromCharCode(
      65 + Math.floor(Math.random() * 26)
    ); // Random uppercase letter
    const lowercaseLetters = Array.from({ length: 2 }, () =>
      String.fromCharCode(97 + Math.floor(Math.random() * 26))
    ).join(""); // Random two lowercase letters
    const digits = Math.floor(100 + Math.random() * 900); // Random three-digit number

    const newPassword = uppercaseLetter + lowercaseLetters + "@" + digits;
    setPassword(newPassword);
  };

  useEffect(() => {
    generatePassword();
  }, []);

  useEffect(() => {
    // Get the URL parameters
    const searchParams = new URLSearchParams(window.location.search);
    const valueofpayment_intent_client_secret = searchParams.get(
      "payment_intent_client_secret"
    );
    setPaymentIntent(valueofpayment_intent_client_secret);
  }, []);

  useEffect(() => {
    const currentDate = new Date(); // Get the current date
    const futureEndDate = new Date(currentDate); // Create a new date object for end date (set to start date)
    futureEndDate.setFullYear(currentDate.getFullYear() + 1); // Set end date 1 year from the start date

    const startDate = Helper.DatePicker(currentDate);
    const endDate = Helper.DatePicker(futureEndDate);

    setStart_date(startDate); // Update start_date state with the future start date
    setEnd_date(endDate); // Update end_date state with the future end date
  }, []);

  const getPlan = async () => {
    await axios.get(API + "company/planpackages/", { params: { name: plan } }, {
      headers: authHeader()
    }).then((res) => {
      if (res.data.success === 1) {
        setplanData(res.data.response)
        setAmount(res.data.response.year_price * 12)
        setUserAllow(res.data.response.number_user)
      }
    })
  }

  useEffect(() => {
    if (plan !== '') {
      getPlan()
    }
  }, [plan])

  useEffect(() => {
    const getcountry = async () => {
      const res = await fetch(API + "helper/ajax/load-countries/");
      const getcon = await res.json();
      setCountry(await getcon);
    };
    getcountry();
  }, []);

  const handlecountry = (event) => {
    const getcoutryid = event.target.value;
    setCountryid(getcoutryid);
  };

  const handlestate = (event) => {
    const getstateid = event.target.value;
    setStateid(getstateid)
  }
  useEffect(() => {
    if (country !== '') {
      const getstate = async () => {
        const resst = await fetch(API + "helper/ajax/load-states/" + country + "/");
        const getst = await resst.json();
        setState(await getst);
      }
      getstate();
    }
  }, [country]);

  const handleRegister = () => {
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      setIsLoading(true)
      AuthService.register(
        name,
        email,
        password,
        company_name,
        address,
        country,
        state,
        city,
        zip_code,
        phone_number,
        plan,
        userAllow,
      ).then(
        (response) => {
          if (response.data.success) {
            setTimeout(() => {
              navigate("/confirmregister")
            }, 2000)

            toast.success(`${response.data.response}`)
            setIsLoading(false)
          }
          else {
            toast.error(`Somthing went wrong.`)
            setIsLoading(false)
          }
        },
      );
    }
  };

  useEffect(() => {

  }, [updatestripeintent])

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        setIPAddress(data.ip);
        handlepaymentintentupdate(data.ip); // Call handlepaymentintentupdate with the IP address
      })
      .catch(error => console.log(error));
    // }
  }, []);

  const handlepaymentintentupdate = async (value) => {

  }
  useEffect(() => {
    if (userAllow > '1') {
      const value = parseInt(parseInt(planData.year_price) * 12) * parseInt(userAllow)
      setAmount(value)
    } else {
      const value2 = parseInt(parseInt(planData.year_price) * 12) * parseInt(userAllow)

      setAmount(value2)
    }
  }, [userAllow])

  const uservalidation = async () => {
    try {
      const response = await axios.post(API + 'accounting/uservalidation/', {
        email
      }, { headers: authHeader() }).then((response) => {
        if (response.data.success == 1) {
          toast.error(`${response.data.response}`, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            // closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          setEmail("")
        }
        else {
          console.log("ok")

        }
      }
      )

    } catch (error) {
      console.error("Error fetching client secret:", error);
    }
  };
  return (
    <div>
      {loading === true && <SpinnerComponent />}
      {isLoading && <SpinnerComponent />}
      <section>
        <ToastContainer autoClose={2000} theme="colored" transition={Zoom} />
        <div className="page-header section-height-70">
          <div className="container" style={{ paddingLeft: 'var(--bs-gutter-x, 1.6rem)', height: 'auto' }}>

            <div className="row" style={{ backgroundColor: 'white', marginTop: '4%', borderRadius: '10px', width: '100%', justifyContent: 'center' }}>
              <div className="row">

                <div className="col-xl-2 col-lg-5 col-md-1 tex-center mt-4 mb-3 ">
                  <button className="font-weight-bold d-flex"
                    style={{ backgroundColor: '#f1e9e9', borderRadius: '5px', border: 'none', fontSize: '10px', width: '70px', justifyContent: 'center', padding: '5px' }}
                    onClick={() => window.location.replace('https://staging.athenafintech.com/pricing/')}
                  >
                    <i class="bi bi-arrow-left"></i>
                    &nbsp;&nbsp;Back
                  </button>               </div>
                <div className="col-xl-8 col-lg-5 col-md-6 tex-center mt-2 mb-3 ">
                  <img
                    src={process.env.PUBLIC_URL + "/static/images/logo.png"}
                    alt="Reimazine"
                    style={{ maxWidth: '160px', maxHeight: '160px', marginTop: '10px' }}
                  />                </div>
              </div>
              <div className="col-xl-8 col-lg-5 col-md-6 tex-center mt-2 mb-3 ">
                <h3 className="tc">Get started with your 15-day free trial.</h3>
              </div>
              <div className="col-xl-8 col-lg-5 col-md-6 d-flex flex-column mx-auto" style={{ marginTop: '-23px' }}>
                <div className=" mt-4 mb-8">
                  <div className="">
                    <><Form role="form text-left"
                      ref={form}
                      onSubmit={handleSubmit(handleRegister)}
                      action="."
                      method="POST"
                      id="companyForm">
                      {(
                        <div className="center red-text">
                          <div className="form-group d-flex">
                            <div className="flex-grow-1 me-3">
                              <label htmlFor="companyname">Company Name</label>
                              <input
                                type="text"
                                name="company_name"
                                value={company_name}
                                className="form-control"
                                placeholder="Company Name"
                                {...register("company_name", {
                                  onChange: (e) => {
                                    setCompnayName(e.target.value);
                                  },
                                  required: true,
                                })} />
                              <div className="invalid-feedback">
                                {errors.company_name?.type === "required" && "Company name is required"}
                              </div>
                            </div>
                            <div className="flex-grow-1">
                              <label htmlFor="name">Name</label>
                              <input
                                type="text"
                                name="name"
                                value={name}
                                className="form-control"
                                placeholder="Name"
                                {...register("name", {
                                  onChange: (e) => {
                                    // trigger();
                                    setName(e.target.value);
                                  },
                                  required: true,
                                })} />
                              <div className="invalid-feedback">
                                {errors.name?.type === "required" && "Name is required"}
                              </div>
                            </div>
                          </div>
                          <div className="form-group d-flex">
                            <div className="flex-grow-1 me-3">
                              <label htmlFor="email">Email</label>
                              <input
                                type="email"
                                value={email}
                                className="form-control"
                                placeholder="Email"
                                name="email"
                                {...register("email", {
                                  onChange: (e) => {
                                    setEmail(e.target.value);
                                  },
                                  onBlur: (e) => { uservalidation(); },

                                  required: 'Enter valid Email',
                                  pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: 'Please enter a valid email',
                                  },
                                })} />
                              <div className="invalid-feedback">{errors.email && errors.email?.message}</div>
                            </div>
                            <div className="flex-grow-1">
                              <label htmlFor="phonenumber">Phone Number</label>
                              <input
                                type="text"
                                name="phone_number"
                                value={phone_number}
                                className="form-control"
                                placeholder="Phone Number"
                                {...register("phone_number", {
                                  onChange: (e) => {
                                    setPhoneNumber(e.target.value);
                                  },
                                  required: true,
                                })} />
                              <div className="invalid-feedback">
                                {errors.phone_number?.type === 'required' && 'Phone Number is required'}
                              </div>
                            </div>
                          </div>
                          <div className="form-group">
                            <label htmlFor="address">Address</label>
                            <input
                              type="text"
                              name="address"
                              value={address}
                              className="form-control"
                              placeholder="Address"
                              {...register("address", {
                                onChange: (e) => {
                                  setAddress(e.target.value);
                                }, required: true
                              })} />
                            <div className="invalid-feedback">

                              {errors.address?.type === 'required' && "Address is required"}
                            </div>
                          </div>
                          <div className="form-group d-flex flex-wrap">
                            <div className="flex-grow-1 me-3 ">
                              <label htmlFor="country">Country</label>
                              <select
                                type="text"
                                name="country"
                                className="form-control"
                                {...register("country", {
                                  onChange: (e) => {
                                    handlecountry(e);
                                  }, required: true
                                })}
                              >
                                <option value=''>---Select Country---</option>
                                {country_name.map((countryget) => (
                                  <option key={countryget.id} value={countryget.id}>{countryget.name}</option>
                                ))}
                              </select>
                              <div className="invalid-feedback">{errors.country?.type === 'required' && 'Country is required'}</div>
                            </div>
                            <div className="flex-grow-1 ">
                              <label htmlFor="state">State</label>
                              <select
                                name="state"
                                className="form-control"
                                {...register("state", {
                                  onChange: (e) => {
                                    handlestate(e);
                                  }, required: true
                                })}
                              >
                                <option value=''>---Select State---</option>
                                {state_name.map((resst) => (
                                  <option key={resst.id} value={resst.id}>{resst.name}</option>
                                ))}
                              </select>
                              <div className="invalid-feedback">{errors.state?.type === 'required' && 'State is required'}</div>
                            </div>

                          </div>
                          <div className="form-group d-flex flex-wrap">

                            <div className="flex-grow-1 me-3 ">
                              <label htmlFor="city">City</label>
                              <input
                                type="text"
                                name="city"
                                value={city}
                                className="form-control"
                                placeholder="City"
                                {...register("city", {
                                  onChange: (e) => {
                                    setCity(e.target.value);
                                  }, required: true
                                })} />
                              <div className="invalid-feedback">{errors.city?.type === 'required' && 'City is required'}</div>
                            </div>
                            <div className="flex-grow-1  ">
                              <label htmlFor="zipcode">Zip Code</label>
                              <input
                                type="text"
                                name="zip_code"
                                value={zip_code}
                                className="form-control"
                                placeholder="Zip Code"
                                {...register("zip_code", {
                                  onChange: (e) => {
                                    setZipCode(e.target.value);
                                  }, required: true
                                })} />
                              <div className="invalid-feedback">{errors.zip_code?.type === 'required' && 'Zip Code is required'}</div>
                            </div>
                          </div>
                          <div className="form-group text-center mt-3">
                            <button className="btn btn-primary account-btn" type="submit"
                            >Register</button>
                          </div>
                        </div>
                      )}
                      <CheckButton style={{ display: "none" }} ref={checkBtn} />
                    </Form><div className="row card-body">
                      </div></>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default SignUp;
